import { jsx, jsxs } from 'react/jsx-runtime';
import { Component } from 'react';
import cn from 'classnames';
import { Paranja } from '../Paranja/Paranja.js';
import { Scroll } from '../Scroll/Scroll.js';
import { Spinner } from '../Spinner/Spinner.js';
import S from './Table.styl.js';

class Table extends Component {
    renderHeaderColumn = ({ id, label, sticky }) => (jsx("th", { className: cn(sticky && S.sticky), children: label }, id));
    renderRow = data => {
        const { columns } = this.props;
        return (jsx("tr", { children: columns.map(param => this.renderDataCol(param, data)) }, data.id));
    };
    renderDataCol({ id, dataField, render, sticky }, data) {
        return (jsx("td", { className: cn(sticky && S.sticky), children: render ? render(data) : data[dataField || id] }, id));
    }
    render() {
        const { className, columns, isLoading = false, loadingText, blur, data, } = this.props;
        return (jsxs("div", { className: cn(S.root, blur && S.blur, className), children: [jsx(Scroll, { x: true, y: true, offset: { x: { before: 10, after: 10 } }, children: jsxs("table", { children: [jsx("thead", { children: jsx("tr", { children: columns.map(this.renderHeaderColumn) }) }), jsx("tbody", { children: data.map(this.renderRow) })] }) }), jsx(Paranja, { inline: true, visible: isLoading, blur: blur, children: isLoading && (loadingText ?? jsx(Spinner, {})) })] }));
    }
}

export { Table };
